var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pill-button',{staticClass:"button",attrs:{"to":`/${_vm.collection.id}`,"label":_vm.collection.label,"year":_vm.collection.year}},[(_vm.$isMobile)?_c('span',{staticClass:"notice"},[_vm._v(_vm._s(_vm.yeardate))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }